function initAnniversary13thRoad(root = document) {
  if (typeof Swiper === 'undefined') return;

  root.querySelectorAll('[data-anniversary-13th-road-swiper]').forEach((carouselEl) => {
    if (carouselEl.swiper) return;

    const section = carouselEl.closest('.anniversary-13th-road');
    const prevEl = section && section.querySelector('.anniversary-13th-road__nav--prev');
    const nextEl = section && section.querySelector('.anniversary-13th-road__nav--next');

    const marqueeSpeed = 6000;
    const jumpSpeed = 450;
    let resumeTimer;
    let hovering = false;

    const swiper = new Swiper(carouselEl, {
      slidesPerView: 1.8,
      spaceBetween: 10,
      loop: true,
      speed: marqueeSpeed,
      grabCursor: true,
      watchOverflow: true,
      allowTouchMove: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
      breakpoints: {
        750: {
          slidesPerView: 2.15,
          spaceBetween: 16,
        },
        990: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
    });

    const resumeMarquee = () => {
      carouselEl.classList.remove('is-jumping');
      swiper.params.speed = marqueeSpeed;
      if (!swiper.autoplay || hovering) return;
      swiper.autoplay.paused = false;
      if (swiper.autoplay.running) {
        if (typeof swiper.autoplay.resume === 'function') swiper.autoplay.resume();
      } else {
        swiper.autoplay.start();
      }
    };

    const stopMarquee = () => {
      window.clearTimeout(resumeTimer);
      if (!swiper.autoplay) return;
      swiper.autoplay.stop();
      swiper.autoplay.paused = false;
    };

    const snapCurrent = () => {
      const x = swiper.getTranslate();
      swiper.setTransition(0);
      swiper.setTranslate(x);
      swiper.updateProgress();
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
      swiper.animating = false;
    };

    const jump = (dir) => {
      stopMarquee();
      snapCurrent();
      carouselEl.classList.add('is-jumping');

      const index = swiper.activeIndex;
      const sizes = swiper.slidesSizesGrid || [];
      const gap = Number(swiper.params.spaceBetween) || 0;
      const step = (sizes[index] || swiper.slides[index]?.offsetWidth || 300) + gap;
      const from = swiper.getTranslate();
      const to = dir === 'next' ? from - step : from + step;

      swiper.setTransition(jumpSpeed);
      swiper.setTranslate(to);

      resumeTimer = window.setTimeout(() => {
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
        if (typeof swiper.loopFix === 'function') swiper.loopFix();
        swiper.animating = false;
        carouselEl.classList.remove('is-jumping');
        swiper.params.speed = marqueeSpeed;
        // Always restart marquee after an arrow jump (ignore hover flag)
        if (swiper.autoplay) {
          swiper.autoplay.paused = false;
          if (swiper.autoplay.running) swiper.autoplay.stop();
          swiper.autoplay.paused = false;
          swiper.autoplay.start();
        }
      }, jumpSpeed + 40);
    };

    if (prevEl) {
      prevEl.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        jump('prev');
      });
    }
    if (nextEl) {
      nextEl.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        jump('next');
      });
    }

    // Pause only over the slides — not the arrow buttons
    carouselEl.addEventListener('mouseenter', () => {
      hovering = true;
      if (swiper.autoplay && swiper.autoplay.running && typeof swiper.autoplay.pause === 'function') {
        swiper.autoplay.pause();
      }
    });
    carouselEl.addEventListener('mouseleave', () => {
      hovering = false;
      if (carouselEl.classList.contains('is-jumping')) return;
      resumeMarquee();
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initAnniversary13thRoad();
});

document.addEventListener('shopify:section:load', (event) => {
  initAnniversary13thRoad(event.target);
});
